import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user'
import server from './modules/server'


Vue.use(Vuex);
// 引入taskNode
import {TaskNode, TaskNodeStore} from 'vue-task-node'
import 'vue-task-node/dist/css/vnode.css'

Vue.use(TaskNode)

const userStore = new Vuex.Store({
    modules: {
        user,
        server,
        TaskNodeStore
    }
});

export default userStore;



// WEBPACK FOOTER //
// ./src/vuex/index.js